/*
 * Кнопка «Изменить параметры» на странице кластера и хранилищ (PostgreSQL, Kafka, MongoDB, RabbitMQ, Valkey): открывает шаблон изменения,
 * заполненный текущими параметрами ресурса из репозитория. Рядом у типов с шаблоном удаления (пока Valkey) —
 * «Удалить»: шаблон <тип>-delete с уже подставленными именем и кластером.
 */
import { Box, Button, Grid, Typography, makeStyles } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { Link as RouterLink } from 'react-router-dom';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  isDeletableResource,
  isEditableResource,
  resourceDeleteUrl,
  resourceEditUrl,
} from '../../lib/resourceEdit';

const useStyles = makeStyles(theme => ({
  bar: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: theme.spacing(2), flexWrap: 'wrap' },
  hint: { color: theme.palette.text.secondary },
  // удаление — красным контуром: данные хранилища удаляются безвозвратно
  danger: {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    '&:hover': { borderColor: theme.palette.error.dark, backgroundColor: 'transparent' },
  },
}));

const HINTS: Record<string, string> = {
  'kubernetes-cluster': 'группы узлов, хосты, компоненты платформы — применяет пайплайн кластера',
  'postgres-cluster': 'инстансы, ресурсы, базы и пользователи — ArgoCD применит после коммита',
  'kafka-cluster': 'брокеры, ресурсы, конфигурация и топики — ArgoCD применит после коммита',
  'mongodb-cluster': 'replica set, ресурсы, пользователи и бэкап — ArgoCD применит после коммита',
  'rabbitmq-cluster': 'узлы, ресурсы, vhost\'ы, пользователи и очереди — ArgoCD применит после коммита',
  'valkey-cluster': 'шарды, реплики, память и ACL-пользователи — ArgoCD применит после коммита',
};

export const EditResourceButton = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  if (!isEditableResource(entity)) return null;
  return (
    <Grid item xs={12}>
      <Box className={classes.bar}>
        <Typography variant="body2" className={classes.hint}>
          {HINTS[String(entity.spec?.type)]}
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<EditIcon />}
          component={RouterLink}
          to={resourceEditUrl(stringifyEntityRef(entity))}
        >
          Изменить параметры
        </Button>
        {isDeletableResource(entity) && (
          <Button
            variant="outlined"
            className={classes.danger}
            startIcon={<DeleteOutlineIcon />}
            component={RouterLink}
            to={resourceDeleteUrl(entity)}
            title="Удалить вместе с данными — с подтверждением именем"
          >
            Удалить
          </Button>
        )}
      </Box>
    </Grid>
  );
};
